import { Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild, ViewChildren } from '@angular/core';
import { PhotoCollectionDto } from '../../../../../models/trofaco/photoCollectionDto';
import { Observable } from 'rxjs';
import { IsInvalidDirective } from '../../../../core/directives/is-invalid.directive';
import { NgForm } from '@angular/forms';
import { UserService } from 'src/app/modules/core/services/user.service';
import { AppUserModel } from 'src/app/models/users/app-user.model';

@Component({
    selector: 'tr [app-collection-row]',
    templateUrl: './collection-row.component.html',
    styles: []
})
export class CollectionRowComponent implements OnInit {
    @ViewChild(NgForm, {static: true}) form: NgForm;
    @ViewChildren(IsInvalidDirective) isInvalidDirectives: IsInvalidDirective[];

    wasSubmitted = false;
    currentUser: AppUserModel;

    @Input()
    addNewMode: boolean = false;
    @Input()
    coll: PhotoCollectionDto;
    @Output()
    collChanged = new EventEmitter<PhotoCollectionDto>();
    private original?: PhotoCollectionDto;

    @HostBinding('class.table-inline-edit-active')
    get isEditing(): boolean {
        return !!this.original || this.addNewMode;
    }

    @Input()
    titles$: Observable<string[]>;

    @Output() onDelete = new EventEmitter<PhotoCollectionDto>();

    constructor(private userService: UserService) {
    }

    ngOnInit() {
        this.getCurrentUser();
    }

    edit() {
        this.original = this.coll;
        this.coll = {...this.coll};
    }

    revert() {
        this.coll = this.original;
        this.markClean();
    }

    apply() {
        if (this.isInvalidDirectives.some(value => value.isInvalid)) {
            this.wasSubmitted = true;
            return;
        }
        this.collChanged.emit(this.coll);
        this.markClean();
    }

    markClean() {
        this.original = undefined;
        this.form.control.markAsPristine();
        this.form.control.markAsUntouched();
        this.wasSubmitted = false;
    }

    async getCurrentUser() {
        this.currentUser = await this.userService.getCurrentUserAsync();
    }
}
